// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"569":"a2a5c762","571":"6b53d8c9","717":"a2a5c762"}[chunkId] + ".chunk.css";
};